import React, { useState } from "react";
import "./Settings.css";

const Settings = () => {
  const [notifications, setNotifications] = useState(true);

  return (
    <div className="settings-card">
      <h1 className="settings-title">Settings</h1>

      <div className="settings-row">
        <span>Email Notifications</span>

        <label className="switch">
          <input
            type="checkbox"
            checked={notifications}
            onChange={() => setNotifications(!notifications)}
          />
          <span className="slider"></span>
        </label>
      </div>
    </div>
  );
};

export default Settings;
